<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title> สิทธิ์ของพนักงาน </v-list-item-title>
            <v-list-item-subtitle>
              {{ employeePolicyInit.employee_code }} -
              {{ employeePolicyInit.firstname_th }}
              {{ employeePolicyInit.lastname_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="$emit('formActionCompleted')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <div>
          <label class="body-2 d-block"> สิทธิ์ส่วนตัว </label>
          <v-card
            v-if="employeePolicy.personal_policy_uuid"
            outlined
            class="mt-1 d-flex justify-space-between align-center"
          >
            <span class="ml-2 body-2">ส่วนตัว</span>
            <v-btn
              icon
              @click="handleDeleteEmployeePersonalRole(employeePolicy)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card>
          <v-btn
            v-if="!employeePolicy.personal_policy_uuid"
            class="mt-1"
            text
            color="primary"
            @click="handleUpdatePersonalRole"
          >
            <v-icon small left>mdi-plus</v-icon> เพิ่มสิทธิ์ส่วนตัว
          </v-btn>
          <v-btn
            v-else
            class="mt-1"
            text
            color="primary"
            @click="handleUpdatePersonalRole"
          >
            <v-icon small left>mdi-pencil</v-icon> แก้ไขสิทธิ์ส่วนตัว
          </v-btn>
        </div>
        <div class="mt-6">
          <label class="body-2"> บทบาท </label>
          <v-card
            v-for="role in employeePolicy.roles"
            :key="role.role_uuid"
            outlined
            class="mt-1 d-flex justify-space-between align-center"
          >
            <span class="ml-2 body-2">{{ role.title }}</span>
            <v-btn icon @click="handleDeleteEmployeePolicyRoles(role)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card>
        </div>
        <v-btn
          class="mt-2"
          text
          color="primary"
          @click="handleAddEmployeePolicyRole"
        >
          <v-icon small left>mdi-plus</v-icon> เพิ่มบทบาท
        </v-btn>
      </div>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeletePersonalRole"
      :loading="confirmDialogDeletePersonalRoleLoading"
      :dialogData="confirmDialogDeletePersonalRoleData"
      @cancelConfirmDialog="cancelConfirmDialogDeletePersonalRole"
      @submitConfirmDialog="submitConfirmDialogDeletePersonalRole"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteCondition"
      :loading="confirmDialogDeleteConditionLoading"
      :dialogData="confirmDialogDeleteConditionData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteCondition"
      @submitConfirmDialog="submitConfirmDialogDeleteCondition"
    />
    <v-dialog v-model="dialogRoles" persistent scrollable max-width="60%">
      <v-card>
        <v-card-title>
          <span>เพิ่มบทบาทให้พนักงาน</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="handleOnCloseDialogRoles">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0" style="height: 520px">
          <v-data-table
            v-model="selectedRoles"
            :headers="[
              {
                text: 'ชื่อบทบาท (Role)',
                align: 'start',
                width: 200,
                value: 'title',
              },
              { text: 'คำอธิบาย', align: 'start', value: 'description' },
            ]"
            :items="userRoles"
            :single-select="false"
            item-key="role_uuid"
            show-select
            hide-default-footer
            :items-per-page="-1"
            class="elevation-1"
          >
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6">
          <v-btn color="primary" @click="handleOnSaveDialogRoles">
            บันทึก
          </v-btn>
          <v-btn @click="handleOnCancelDialogRoles"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPersonalRole"
      persistent
      scrollable
      max-width="60%"
    >
      <v-card>
        <v-card-title>
          <span>จัดการสิทธิ์ส่วนตัว</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-6" style="height: 520px">
          <h2>พนักงาน</h2>
          <div class="mt-4">
            <h3>- {{ employeePolicyInit.employee_code }}</h3>
            <h3 class="mt-1">
              - {{ employeePolicyInit.firstname_th }}
              {{ employeePolicyInit.lastname_th }}
            </h3>
            <h3 class="mt-1">
              - {{ employeePolicyInit.organization.title_th }}
            </h3>
            <h3 class="mt-1">- {{ employeePolicyInit.position.title_th }}</h3>
          </div>

          <!-- USER_ROLE_LIST -->
          <v-row class="mt-1">
            <v-col cols="12" md="12">
              <v-expansion-panels multiple v-model="panel">
                <v-expansion-panel
                  v-for="statement in employeePersonalPolicy.personal_policy
                    .Statements"
                  :key="statement.id"
                >
                  <v-expansion-panel-header class="pl-2 py-1">
                    <template v-slot:default>
                      <div class="d-flex align-center">
                        <v-btn
                          icon
                          @click.stop="handleDeleteRole(statement.id)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <span class="ml-2">
                          {{ statement.TitleTH || 'เลือกสิทธิ์' }}
                        </span>
                      </div>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content v-if="statement.TitleTH">
                    <p class="mb-1">การอนุญาต</p>
                    <div v-for="(action, i) in statement.Actions" :key="i">
                      <v-card outlined class="px-4 py-2 mb-3">
                        <div v-for="(subAction, i) in action.Actions" :key="i">
                          <input
                            type="checkbox"
                            :id="subAction.TitleTH"
                            v-model="subAction.checked"
                          />
                          <label :for="subAction.TitleTH" class="ml-2">
                            {{ subAction.TitleTH }}
                          </label>
                        </div>
                        <div>
                          <div
                            class="mt-4 mb-2"
                            v-if="
                              action.Conditions &&
                              (action.Conditions.MustHaveAll ||
                                action.Conditions.AtLeastOne)
                            "
                          >
                            <v-btn
                              :disabled="!action.Actions.some((s) => s.checked)"
                              outlined
                              @click="handleChangeCondition(statement, action)"
                            >
                              เปลี่ยนเงื่อนไข
                            </v-btn>
                            <v-btn
                              :disabled="!action.Actions.some((s) => s.checked)"
                              class="ml-4"
                              color="error"
                              text
                              @click="
                                handleDeleteCondition(
                                  statement.TitleTH,
                                  action.id
                                )
                              "
                              >ลบเงื่อนไข</v-btn
                            >
                          </div>
                          <div
                            class="mt-4 mb-2"
                            v-else-if="action.hasProperties"
                          >
                            <v-btn
                              :disabled="!action.Actions.some((s) => s.checked)"
                              outlined
                              @click="handleSetCondition(statement, action)"
                            >
                              กำหนดเงื่อนไข
                            </v-btn>
                          </div>
                        </div>
                      </v-card>
                    </div>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content v-else>
                    <v-btn
                      style="width: 200px"
                      outlined
                      @click="handleChooseRole(statement.id)"
                    >
                      เลือกสิทธิ์
                    </v-btn>
                    <v-dialog
                      v-model="dialogAddUserRole"
                      scrollable
                      max-width="520px"
                    >
                      <v-card>
                        <v-card-text class="pa-0" style="height: 560px">
                          <div
                            v-for="(
                              group, i
                            ) in policySpecification.PolicyGroups"
                            :key="i"
                          >
                            <h3 class="px-4 py-2 grey lighten-3">
                              {{ group.TitleTH }}
                            </h3>
                            <ul class="py-2">
                              <li
                                v-for="(resource, i) in group.Resources"
                                :key="i"
                                style="
                                  list-style: none;
                                  margin: 8px 16px;
                                  cursor: pointer;
                                "
                                class="btn-link"
                                @click="handleSelectedRole(resource)"
                              >
                                <div
                                  v-if="
                                    policySpecification.PolicySpecs[resource]
                                  "
                                >
                                  {{
                                    policySpecification.PolicySpecs[resource]
                                      .TitleTH
                                  }}
                                </div>
                              </li>
                            </ul>
                            <div
                              style="
                                padding-bottom: 16px;
                                text-align: center;
                                color: grey;
                              "
                              v-if="group.Resources.length === 0"
                            >
                              สิทธิ์ถูกเพิ่มไปแล้ว
                            </div>
                            <v-divider></v-divider>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <!-- USER_ROLE_LIST -->

          <v-row>
            <v-col cols="12" md="5">
              <v-btn outlined @click="handleAddRole">
                <v-icon small left>mdi-plus</v-icon>เพิ่มสิทธิ์
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6">
          <v-btn
            color="primary"
            :disabled="!isEmployeePersonalPolicyDataChange"
            @click="onSave"
          >
            บันทึก
          </v-btn>
          <v-btn @click="handleCancelDialogPersonalRole"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSetConditions" width="800" persistent scrollable>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          กำหนดเงื่อนไข
        </v-card-title>

        <v-card-text class="px-0 py-2">
          <v-tabs
            v-model="tabSetConditions"
            style="border-bottom: 1px solid #eeeeee"
          >
            <v-tab
              >อนุญาตเมื่อผ่านบางเงื่อนไข
              <v-avatar
                class="ml-2"
                :color="tabSetConditions === 0 ? 'primary' : 'grey'"
                size="24"
              >
                <span class="white--text subtitle-2">
                  {{ setConditionAtLeastOneList.length }}
                </span>
              </v-avatar>
            </v-tab>
            <v-tab
              >อนุญาตเมื่อผ่านทุกเงื่อนไข
              <v-avatar
                class="ml-2"
                :color="tabSetConditions === 1 ? 'primary' : 'grey'"
                size="24"
              >
                <span class="white--text subtitle-2">
                  {{ setConditionMustHaveAllList.length }}
                </span>
              </v-avatar>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabSetConditions">
            <v-tab-item>
              <div class="px-3 py-3 d-flex">
                <v-chip
                  ><v-icon left color="warning">mdi-alert-circle</v-icon
                  >ต้องตรงตามเงื่อนไข
                  <span class="ml-1" style="text-decoration: underline"
                    >อย่างน้อย 1 เงื่อนไข</span
                  ></v-chip
                ><v-btn outlined class="ml-auto" @click="handleAddConditions"
                  >เพิ่ม</v-btn
                >
              </div>
              <v-divider></v-divider>
              <div style="height: 420px; overflow-y: auto" class="px-4 py-4">
                <v-card
                  outlined
                  class="px-1 py-1 mb-3"
                  v-for="condition in setConditionAtLeastOneList"
                  :key="condition.id"
                >
                  <div class="d-flex align-center justify-space-between">
                    <div class="ml-3">
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'employee_uuid'"
                      >
                        พนักงาน
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'organization_uuid'"
                      >
                        หน่วยงาน
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'position_uuid'"
                      >
                        ตำแหน่ง
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'hardware_uuid'"
                      >
                        Device
                      </p>
                    </div>
                    <div>
                      <v-btn
                        text
                        color="primary"
                        small
                        @click="handleEditSetCondition(condition)"
                        >แก้ไข</v-btn
                      >|<v-btn
                        text
                        color="error"
                        small
                        @click="handleDeleteSetCondition(condition.id)"
                        >ลบ</v-btn
                      >
                    </div>
                  </div>
                  <div class="px-3">
                    <v-chip small v-if="condition.comparison === 'in'">
                      อยู่ในรายการ
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'employee'"
                      class="mb-1"
                    >
                      พนักงานที่กำลังใช้งาน
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'organization'"
                      class="mb-1"
                    >
                      หน่วยงานของตนเอง
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'organization_under'"
                      class="mb-1"
                    >
                      หน่วยงานของตนเอง และใต้สังกัด
                    </v-chip>
                    <v-chip
                      small
                      v-if="
                        condition.comparison === 'organization_select_under'
                      "
                      class="mb-1"
                    >
                      หน่วยงานที่เลือก และใต้สังกัด
                    </v-chip>
                  </div>
                  <div
                    v-if="condition.comparison === 'organization_select_under'"
                  >
                    <ul style="list-style: none" class="my-1 pl-3">
                      <li
                        v-for="organization in condition.dataIn"
                        :key="organization.organization_uuid"
                      >
                        - {{ organization.organization_code }}:
                        {{ organization.title_th }}
                      </li>
                    </ul>
                  </div>
                  <div v-if="condition.comparison === 'in'">
                    <ul
                      v-if="condition.resource === 'employee_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="employee in condition.dataIn"
                        :key="employee.employee_uuid"
                      >
                        - {{ employee.firstname_th }}
                        {{ employee.lastname_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'hardware_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="hardware in condition.dataIn"
                        :key="hardware.hardware_uuid"
                      >
                        - {{ hardware.hardware_code }}: {{ hardware.title_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'position_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="position in condition.dataIn"
                        :key="position.position_uuid"
                      >
                        - {{ position.position_code }}: {{ position.title_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'organization_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="organization in condition.dataIn"
                        :key="organization.organization_uuid"
                      >
                        - {{ organization.organization_code }}:
                        {{ organization.title_th }}
                      </li>
                    </ul>
                  </div>
                </v-card>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div class="px-3 py-3 d-flex">
                <v-chip
                  ><v-icon left color="warning">mdi-alert-circle</v-icon
                  >ต้องตรงตามเงื่อนไข
                  <span class="ml-1" style="text-decoration: underline"
                    >ทุกเงื่อนไข</span
                  ></v-chip
                ><v-btn outlined class="ml-auto" @click="handleAddConditions"
                  >เพิ่ม</v-btn
                >
              </div>
              <v-divider></v-divider>
              <div style="height: 420px; overflow-y: auto" class="px-4 py-4">
                <v-card
                  outlined
                  class="px-1 py-1 mb-3"
                  v-for="condition in setConditionMustHaveAllList"
                  :key="condition.id"
                >
                  <div class="d-flex align-center justify-space-between">
                    <div class="ml-3">
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'employee_uuid'"
                      >
                        พนักงาน
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'organization_uuid'"
                      >
                        หน่วยงาน
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'position_uuid'"
                      >
                        ตำแหน่ง
                      </p>
                      <p
                        class="ma-0"
                        v-if="condition.resource === 'hardware_uuid'"
                      >
                        Device
                      </p>
                    </div>
                    <div>
                      <v-btn
                        text
                        color="primary"
                        small
                        @click="handleEditSetCondition(condition)"
                        >แก้ไข</v-btn
                      >|<v-btn
                        text
                        color="error"
                        small
                        @click="handleDeleteSetCondition(condition.id)"
                        >ลบ</v-btn
                      >
                    </div>
                  </div>
                  <div class="px-3">
                    <v-chip small v-if="condition.comparison === 'in'">
                      อยู่ในรายการ
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'employee'"
                      class="mb-1"
                    >
                      พนักงานที่กำลังใช้งาน
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'organization'"
                      class="mb-1"
                    >
                      หน่วยงานของตนเอง
                    </v-chip>
                    <v-chip
                      small
                      v-if="condition.comparison === 'organization_under'"
                      class="mb-1"
                    >
                      หน่วยงานของตนเอง และใต้สังกัด
                    </v-chip>
                    <v-chip
                      small
                      v-if="
                        condition.comparison === 'organization_select_under'
                      "
                      class="mb-1"
                    >
                      หน่วยงานที่เลือก และใต้สังกัด
                    </v-chip>
                  </div>
                  <div
                    v-if="condition.comparison === 'organization_select_under'"
                  >
                    <ul style="list-style: none" class="my-1 pl-3">
                      <li
                        v-for="organization in condition.dataIn"
                        :key="organization.organization_uuid"
                      >
                        - {{ organization.organization_code }}:
                        {{ organization.title_th }}
                      </li>
                    </ul>
                  </div>
                  <div v-if="condition.comparison === 'in'">
                    <ul
                      v-if="condition.resource === 'employee_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="employee in condition.dataIn"
                        :key="employee.employee_uuid"
                      >
                        - {{ employee.firstname_th }}
                        {{ employee.lastname_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'hardware_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="hardware in condition.dataIn"
                        :key="hardware.hardware_uuid"
                      >
                        - {{ hardware.hardware_code }}: {{ hardware.title_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'position_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="position in condition.dataIn"
                        :key="position.position_uuid"
                      >
                        - {{ position.position_code }}: {{ position.title_th }}
                      </li>
                    </ul>
                    <ul
                      v-if="condition.resource === 'organization_uuid'"
                      style="list-style: none"
                      class="my-1 pl-3"
                    >
                      <li
                        v-for="organization in condition.dataIn"
                        :key="organization.organization_uuid"
                      >
                        - {{ organization.organization_code }}:
                        {{ organization.title_th }}
                      </li>
                    </ul>
                  </div>
                </v-card>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            :disabled="!isSetConditionChange"
            color="primary"
            @click="handleSaveSetCondition"
          >
            บันทึก
          </v-btn>
          <v-btn @click="handleCancelSetCondition"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddConditions" width="640" persistent scrollable>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          <span v-if="statusSetCondition === 'add'">เพิ่มเงื่อนไข</span>
          <span v-else>แก้ไขเงื่อนไข</span>
        </v-card-title>

        <v-card-text class="px-4 py-4" style="height: 480px">
          <div>
            <label>
              เงื่อนไขของ "{{ selectedConditionStatement.TitleTH }}"
            </label>
            <v-autocomplete
              v-model="selectedConditionResource"
              :items="conditionResources"
              outlined
              dense
              color="blue-grey lighten-2"
              item-text="name"
              item-value="property"
              placeholder="เลือกเงื่อนไข"
              :disabled="statusSetCondition === 'edit'"
              @change="handleChangeConditionResource"
            >
            </v-autocomplete>
          </div>

          <div v-if="selectedConditionResource">
            <div>
              <label>การเปรียบเทียบ</label>
              <div
                v-if="selectedConditionResource === 'employee_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="in"
                  value="in"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="in" class="ml-2">พนักงานที่เลือก</label>
              </div>
              <div
                v-if="selectedConditionResource === 'organization_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="in"
                  value="in"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="in" class="ml-2">หน่วยงานที่เลือก</label>
              </div>
              <div
                v-if="selectedConditionResource === 'organization_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="organization_select_under"
                  value="organization_select_under"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="organization_select_under" class="ml-2">
                  หน่วยงานที่เลือก และใต้สังกัด
                </label>
              </div>
              <div
                v-if="selectedConditionResource === 'organization_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="organization"
                  value="organization"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="organization" class="ml-2">
                  หน่วยงานของตนเอง
                </label>
              </div>
              <div
                v-if="selectedConditionResource === 'organization_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="organization_under"
                  value="organization_under"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="organization_under" class="ml-2">
                  หน่วยงานของตนเอง และใต้สังกัด
                </label>
              </div>
              <div
                v-if="selectedConditionResource === 'employee_uuid'"
                class="d-flex align-center py-1"
              >
                <input
                  type="radio"
                  id="employee"
                  value="employee"
                  v-model="conditionComparison"
                  :disabled="selectedDataIn.length > 0"
                />
                <label for="employee" class="ml-2">พนักงานที่กำลังใช้งาน</label>
              </div>
            </div>

            <div class="d-flex flex-column mt-4">
              <div class="d-flex align-baseline">
                <label>ข้อมูล</label>
                <div class="ml-4" v-if="selectedDataIn.length">
                  <v-btn
                    text
                    small
                    color="primary"
                    @click="handleSelectData('edit')"
                    >แก้ไข</v-btn
                  >|<v-btn
                    text
                    small
                    color="error"
                    @click="handleClearSelectData"
                    >ล้าง</v-btn
                  >
                </div>
              </div>
              <div v-if="selectedDataIn.length" class="mt-1">
                <div v-if="selectedConditionResource === 'employee_uuid'">
                  <div
                    v-for="employee in selectedDataIn"
                    :key="employee.employee_uuid"
                  >
                    - {{ employee.firstname_th }}
                    {{ employee.lastname_th }}
                  </div>
                </div>
                <div v-if="selectedConditionResource === 'hardware_uuid'">
                  <div
                    v-for="hardware in selectedDataIn"
                    :key="hardware.hardware_uuid"
                  >
                    - {{ hardware.hardware_code }}: {{ hardware.title_th }}
                  </div>
                </div>
                <div v-if="selectedConditionResource === 'organization_uuid'">
                  <div
                    v-for="organization in selectedDataIn"
                    :key="organization.organization_uuid"
                  >
                    - {{ organization.organization_code }}:
                    {{ organization.title_th }}
                  </div>
                </div>
                <div v-if="selectedConditionResource === 'position_uuid'">
                  <div
                    v-for="position in selectedDataIn"
                    :key="position.position_uuid"
                  >
                    - {{ position.position_code }}: {{ position.title_th }}
                  </div>
                </div>
              </div>
              <div v-else>
                <v-btn
                  outlined
                  style="width: 200px"
                  class="mt-1"
                  :disabled="
                    conditionComparison === 'employee' ||
                    conditionComparison === 'organization' ||
                    conditionComparison === 'organization_under'
                  "
                  @click="handleSelectData('choose')"
                  >เลือก</v-btn
                >
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="primary"
            @click="handleAddCondition"
            :disabled="
              !selectedConditionResource ||
              (!selectedDataIn.length &&
                conditionComparison !== 'employee' &&
                conditionComparison !== 'organization' &&
                conditionComparison !== 'organization_under')
            "
          >
            ตกลง
          </v-btn>
          <v-btn @click="handleCancelAddCondition"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSelectedData" width="480" persistent scrollable>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          เลือกข้อมูล
        </v-card-title>

        <div class="px-3 py-2">
          <v-text-field
            v-model="searchSelectedData"
            dense
            outlined
            hide-details
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </div>

        <v-card-text class="px-4" style="height: 360px">
          <div>
            <div v-if="selectedConditionResource === 'employee_uuid'">
              <div
                v-for="employee in employees"
                :key="employee.employee_uuid"
                class="d-flex align-center py-1"
              >
                <input
                  type="checkbox"
                  :id="employee.employee_uuid"
                  :value="employee"
                  v-model="selectedData"
                />
                <label :for="employee.employee_uuid" class="ml-2">
                  {{ employee.firstname_th }} {{ employee.lastname_th }}
                </label>
              </div>
            </div>
            <div v-if="selectedConditionResource === 'organization_uuid'">
              <div
                v-for="organization in organizations"
                :key="organization.organization_uuid"
                class="d-flex align-center py-1"
              >
                <input
                  :type="
                    conditionComparison === 'organization_select_under'
                      ? 'radio'
                      : 'checkbox'
                  "
                  :id="organization.organization_uuid"
                  :value="organization"
                  v-model="selectedData"
                />
                <label :for="organization.organization_uuid" class="ml-2">
                  {{ organization.organization_code }}:
                  {{ organization.title_th }}
                </label>
              </div>
            </div>
            <div v-if="selectedConditionResource === 'position_uuid'">
              <div
                v-for="position in positions"
                :key="position.position_uuid"
                class="d-flex align-center py-1"
              >
                <input
                  type="checkbox"
                  :id="position.position_uuid"
                  :value="position"
                  v-model="selectedData"
                />
                <label :for="position.position_uuid" class="ml-2">
                  {{ position.position_code }}: {{ position.title_th }}
                </label>
              </div>
            </div>
            <div v-if="selectedConditionResource === 'hardware_uuid'">
              <div
                v-for="hardware in hardwares"
                :key="hardware.hardware_uuid"
                class="d-flex align-center py-1"
              >
                <input
                  type="checkbox"
                  :id="hardware.hardware_uuid"
                  :value="hardware"
                  v-model="selectedData"
                />
                <label :for="hardware.hardware_uuid" class="ml-2">
                  {{ hardware.hardware_code }}: {{ hardware.title_th }}
                </label>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" @click="handleSubmitSelectedData">
            ตกลง
          </v-btn>
          <v-btn @click="handleCancelSelectedData"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-navigation-drawer>
</template>

<script>
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    employeePolicy: {
      type: Object,
    },
    employeePolicyInit: {
      type: Object,
    },
  },
  data() {
    return {
      dialogForbidden: false,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      searchSelectedData: '',
      selectedData: [],
      selectedDataInit: [],
      statusSetCondition: '',
      statusSetConditionEditId: '',
      setConditionMustHaveAllList: [],
      setConditionMustHaveAllListInit: [],
      setConditionAtLeastOneList: [],
      setConditionAtLeastOneListInit: [],
      selectedConditionStatement: {},
      selectedConditionActions: [],
      selectedConditionActionId: '',
      selectedConditionPropertiesString: [],
      selectedConditionResource: '',
      conditionComparison: 'in',
      selectedDataIn: [],
      selectedDataInInit: [],
      tabSetConditions: 0,
      dialogSelectedData: false,
      dialogSetConditions: false,
      dialogAddConditions: false,
      dialogAddUserRole: false,
      selectedRoles: [],
      panel: [],
      dialogRoles: false,
      dialogPersonalRole: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      confirmDialogDeletePersonalRole: false,
      confirmDialogDeletePersonalRoleLoading: false,
      confirmDialogDeletePersonalRoleData: {},
      confirmDialogDeleteCondition: false,
      confirmDialogDeleteConditionLoading: false,
      confirmDialogDeleteConditionData: {},
      statementId: '',
      employeePersonalPolicy: {
        personal_policy: {
          Statements: [],
        },
      },
      employeePersonalPolicyInit: {
        personal_policy: {
          Statements: [],
        },
      },
    }
  },
  computed: {
    isSetConditionChange() {
      if (
        JSON.stringify(this.setConditionMustHaveAllList) !==
          JSON.stringify(this.setConditionMustHaveAllListInit) ||
        JSON.stringify(this.setConditionAtLeastOneList) !==
          JSON.stringify(this.setConditionAtLeastOneListInit)
      ) {
        return true
      }
      return false
    },
    positions() {
      return this.$store.state.position.positions.filter(
        (position) =>
          position.title_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase()) ||
          position.position_code
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase())
      )
    },
    hardwares() {
      return this.$store.state.hardware.hardwares.filter(
        (hardware) =>
          hardware.title_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase()) ||
          hardware.hardware_code
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase())
      )
    },
    organizations() {
      return this.$store.state.organization.organizations.filter(
        (organization) =>
          organization.title_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase()) ||
          organization.organization_code
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase())
      )
    },
    employees() {
      return this.$store.state.employee.employees.filter(
        (employee) =>
          employee.firstname_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase()) ||
          employee.lastname_th
            .toLowerCase()
            .includes(this.searchSelectedData.toLowerCase())
      )
    },
    isEmployeePersonalPolicyDataChange() {
      if (
        JSON.stringify(
          this.employeePersonalPolicy.personal_policy.Statements
        ) !==
        JSON.stringify(
          this.employeePersonalPolicyInit.personal_policy.Statements
        )
      ) {
        return true
      }
      return false
    },
    userRoles() {
      return this.$store.state.userRole.userRoles
    },
    conditionResources() {
      let resources = []

      this.selectedConditionPropertiesString.forEach((property) => {
        const propertyKey = property.Property.split(':').pop()
        const propertyText = {
          employee_uuid: 'พนักงาน',
          organization_uuid: 'หน่วยงาน',
          position_uuid: 'ตำแหน่ง',
          hardware_uuid: 'Device',
        }

        if (Object.keys(propertyText).includes(propertyKey)) {
          resources.push({
            name: propertyText[propertyKey],
            property: propertyKey,
            disabled:
              this.tabSetConditions === 0
                ? this.setConditionAtLeastOneList.some(
                    (item) => item.resource === propertyKey
                  )
                : this.setConditionMustHaveAllList.some(
                    (item) => item.resource === propertyKey
                  ),
          })
        }
      })

      return resources
    },
    policySpecification() {
      return {
        PolicyGroups:
          this.$store.state.userRole.policySpecification.PolicyGroups.map(
            (group) => {
              return {
                ...group,
                Resources: group.Resources.filter((resource) => {
                  return !this.employeePersonalPolicy.personal_policy.Statements.some(
                    (statement) => statement.Resource === resource
                  )
                }),
              }
            }
          ),
        PolicySpecs: this.$store.state.userRole.policySpecification.PolicySpecs,
      }
    },
  },
  methods: {
    ...mapActions({
      fetchEmployeePolicy: 'employeePolicy/fetchEmployeePolicy',
      deleteEmployeePersonalPolicy:
        'employeePolicy/deleteEmployeePersonalPolicy',
      updateEmployeePersonalPolicy:
        'employeePolicy/updateEmployeePersonalPolicy',
      fetchPolicySpecification: 'userRole/fetchPolicySpecification',
      fetchEmployeePersonalPolicy: 'employeePolicy/fetchEmployeePersonalPolicy',
      fetchUserRoles: 'userRole/fetchUserRoles',
      updateEmployeePolicyRoles: 'employeePolicy/updateEmployeePolicyRoles',
      fetchEmployees: 'employee/fetchEmployees',
      fetchOrganizations: 'organization/fetchOrganizations',
      fetchPositions: 'position/fetchPositions',
      fetchHardwares: 'hardware/fetchHardwares',
    }),
    handleAddConditions() {
      this.dialogAddConditions = true
      this.statusSetCondition = 'add'
    },
    async handleSaveSetCondition() {
      try {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const Conditions = {
          AtLeastOne: this.setConditionAtLeastOneList.reduce(
            (a, v) => ({
              ...a,
              [`prop:::${v.resource.split('_')[0]}:${v.resource}`]:
                v.comparison === 'in'
                  ? { StringIn: v.dataIn.map((data) => data[v.resource]) }
                  : v.comparison === 'employee'
                  ? { UserPropEqual: 'user:::employee:employee_uuid' }
                  : v.comparison === 'organization'
                  ? {
                      UserPropEqual:
                        'user:::employee:organization:organization_uuid',
                    }
                  : v.comparison === 'organization_under'
                  ? {
                      ValidationFunc: {
                        Function: 'func:::IsOrgPropInUserOrgPropTree',
                        UserArg:
                          'user:::employee:organization:organization_uuid',
                      },
                    }
                  : v.comparison === 'organization_select_under'
                  ? {
                      ValidationFunc: {
                        Function: 'func:::IsOrgPropInUserOrgPropTree',
                        StringArg: v.dataIn.map((data) => data[v.resource])[0],
                      },
                    }
                  : {},
            }),
            {}
          ),
          MustHaveAll: this.setConditionMustHaveAllList.reduce(
            (a, v) => ({
              ...a,
              [`prop:::${v.resource.split('_')[0]}:${v.resource}`]:
                v.comparison === 'in'
                  ? { StringIn: v.dataIn.map((data) => data[v.resource]) }
                  : v.comparison === 'employee'
                  ? { UserPropEqual: 'user:::employee:employee_uuid' }
                  : v.comparison === 'organization'
                  ? {
                      UserPropEqual:
                        'user:::employee:organization:organization_uuid',
                    }
                  : v.comparison === 'organization_under'
                  ? {
                      ValidationFunc: {
                        Function: 'func:::IsOrgPropInUserOrgPropTree',
                        UserArg:
                          'user:::employee:organization:organization_uuid',
                      },
                    }
                  : v.comparison === 'organization_select_under'
                  ? {
                      ValidationFunc: {
                        Function: 'func:::IsOrgPropInUserOrgPropTree',
                        StringArg: v.dataIn.map((data) => data[v.resource])[0],
                      },
                    }
                  : {},
            }),
            {}
          ),
        }

        const Statements = []
        this.employeePersonalPolicy.personal_policy.Statements.forEach(
          (statement) => {
            statement.Actions.forEach((action) => {
              Statements.push({
                Effect: 'Allow',
                Resource: statement.Resource,
                Actions: action.Actions.filter((action) => action.checked).map(
                  (action) => action.Action
                ),
                Conditions:
                  action.id === this.selectedConditionActionId
                    ? action.Actions.some((s) =>
                        this.selectedConditionActions.includes(s.Action)
                      )
                      ? Conditions
                      : {}
                    : action.Conditions,
              })
            })
          }
        )

        const employeePersonalPolicy = {
          personal_policy: {
            Version: this.employeePersonalPolicy.personal_policy.Version || 1,
            Statements,
          },
        }

        const payload = {
          company_uuid,
          employee_uuid: this.employeePolicy.employee_uuid,
          data: employeePersonalPolicy,
        }

        await this.updateEmployeePersonalPolicy(payload)

        await this.fetchEmployeePersonalPolicy({
          company_uuid,
          employee_uuid: this.employeePolicy.employee_uuid,
        })
        this.employeePersonalPolicyFormatData()

        const response = await this.fetchEmployeePolicy(payload)
        this.$emit('updateEmployeePolicyRoles', response)

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'บันทึกข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
        this.dialogSetConditions = false

        this.setConditionMustHaveAllList = []
        this.setConditionAtLeastOneList = []
      }
    },
    handleCancelSetCondition() {
      this.dialogSetConditions = false
      this.setConditionMustHaveAllList = []
      this.setConditionAtLeastOneList = []
    },
    handleChangeConditionResource() {
      this.selectedDataIn = []
      this.selectedDataInInit = []

      this.selectedData = []
    },
    handleAddCondition() {
      if (this.statusSetCondition === 'edit') {
        if (this.tabSetConditions === 0) {
          this.setConditionAtLeastOneList = this.setConditionAtLeastOneList.map(
            (condition) => {
              if (condition.id === this.statusSetConditionEditId) {
                return {
                  id: this.statusSetConditionEditId,
                  resource: this.selectedConditionResource,
                  comparison: this.conditionComparison,
                  dataIn: this.selectedDataIn,
                }
              }

              return condition
            }
          )
        }

        if (this.tabSetConditions === 1) {
          this.setConditionMustHaveAllList =
            this.setConditionMustHaveAllList.map((condition) => {
              if (condition.id === this.statusSetConditionEditId) {
                return {
                  id: this.statusSetConditionEditId,
                  resource: this.selectedConditionResource,
                  comparison: this.conditionComparison,
                  dataIn: this.selectedDataIn,
                }
              }

              return condition
            })
        }

        this.selectedConditionResource = ''
        // this.conditionComparison = 'in'
        this.selectedDataIn = []
        this.selectedDataInInit = []

        this.selectedData = []

        this.dialogAddConditions = false
        return
      }

      const condition = {
        id: uuidv4(),
        resource: this.selectedConditionResource,
        comparison: this.conditionComparison,
        dataIn: this.selectedDataIn,
      }

      if (this.tabSetConditions === 0) {
        const index = this.setConditionAtLeastOneList.findIndex(
          (item) => item.resource === condition.resource
        )

        if (index !== -1) {
          this.setConditionAtLeastOneList.splice(index, 1, condition)
        } else {
          this.setConditionAtLeastOneList.push(condition)
        }
      }

      if (this.tabSetConditions === 1) {
        const index = this.setConditionMustHaveAllList.findIndex(
          (item) => item.resource === condition.resource
        )

        if (index !== -1) {
          this.setConditionMustHaveAllList.splice(index, 1, condition)
        } else {
          this.setConditionMustHaveAllList.push(condition)
        }
      }

      this.selectedConditionResource = ''
      // this.conditionComparison = 'in'
      this.selectedDataIn = []
      this.selectedDataInInit = []

      this.selectedData = []

      this.dialogAddConditions = false
    },
    handleCancelAddCondition() {
      this.selectedConditionResource = ''
      this.conditionComparison = 'in'
      this.selectedDataIn = []
      this.selectedDataInInit = []

      this.selectedData = []

      this.dialogAddConditions = false
    },
    handleSubmitSelectedData() {
      this.selectedDataIn =
        this.conditionComparison === 'organization_select_under'
          ? [{ ...this.selectedData }]
          : [...this.selectedData]

      this.searchSelectedData = ''
      this.dialogSelectedData = false
    },
    handleCancelSelectedData() {
      this.selectedData = [...this.selectedDataInit]
      this.searchSelectedData = ''
      this.dialogSelectedData = false
    },
    async handleSetCondition(statement, action) {
      this.selectedConditionStatement = statement

      this.selectedConditionActions = action.Actions.map((item) => item.Action)
      this.selectedConditionActionId = action.id

      this.selectedConditionPropertiesString = [...action.Properties.String]

      this.dialogSetConditions = true
    },
    async handleSelectData(state) {
      if (state === 'edit') {
        this.selectedData = [...this.selectedDataIn]
        // this.selectedDataInit = [...this.selectedDataIn]
        this.dialogSelectedData = true
        return
      }
      try {
        if (this.selectedConditionResource === 'employee_uuid') {
          this.$store.state.loading = true

          const payload = {
            company_uuid: this.$store.state.authentication.company.company_uuid,
            params: {
              dpc: 'role-to-list-employee',
              is_active: true,
              sort: 'employee_code:asc',
              preset: 'selector',
            },
          }
          await this.fetchEmployees(payload)
        }

        if (this.selectedConditionResource === 'organization_uuid') {
          this.$store.state.loading = true

          const payload = {
            company_uuid: this.$store.state.authentication.company.company_uuid,
            params: {
              dpc: 'role-to-list-organization',
              sort: 'organization_code:asc',
              field: 'organization_uuid,organization_code,title_th',
            },
          }
          await this.fetchOrganizations(payload)
        }

        if (this.selectedConditionResource === 'position_uuid') {
          this.$store.state.loading = true

          const payload = {
            company_uuid: this.$store.state.authentication.company.company_uuid,
            params: {
              dpc: 'role-to-list-position',
            },
          }
          await this.fetchPositions(payload)
        }

        if (this.selectedConditionResource === 'hardware_uuid') {
          this.$store.state.loading = true

          const payload = {
            params: {
              dpc: 'role-to-list-hardware',
              company_uuid:
                this.$store.state.authentication.company.company_uuid,
            },
          }
          await this.fetchHardwares(payload)
        }

        this.dialogSelectedData = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    handleClearSelectData() {
      this.selectedDataIn = []
      this.selectedDataInInit = []

      this.selectedData = []
    },
    handleEditSetCondition(condition) {
      this.selectedConditionResource = condition.resource
      this.conditionComparison = condition.comparison
      this.selectedDataIn = [...condition.dataIn]
      this.selectedDataInInit = [...condition.dataIn]

      this.dialogAddConditions = true
      this.statusSetCondition = 'edit'
      this.statusSetConditionEditId = condition.id
    },
    handleDeleteSetCondition(id) {
      if (this.tabSetConditions === 0) {
        this.setConditionAtLeastOneList =
          this.setConditionAtLeastOneList.filter(
            (condition) => condition.id !== id
          )
      }
      if (this.tabSetConditions === 1) {
        this.setConditionMustHaveAllList =
          this.setConditionMustHaveAllList.filter(
            (condition) => condition.id !== id
          )
      }
      if (this.statusSetConditionEditId === id) {
        this.statusSetCondition = ''
        this.statusSetConditionEditId = ''
      }
    },
    async handleChangeCondition(statement, action) {
      this.selectedConditionStatement = statement

      this.selectedConditionActions = action.Actions.map((item) => item.Action)

      this.selectedConditionActionId = action.id

      const actionsStatement =
        this.$store.state.employeePolicy.employeePersonalPolicy.personal_policy.Statements.find(
          (statement) =>
            statement.Actions.some((action) =>
              this.selectedConditionActions.includes(action)
            )
        )

      if (!actionsStatement) {
        this.dialogSetConditions = true
        return
      }

      const conditions = actionsStatement.Conditions
      if (conditions.MustHaveAll || conditions.AtLeastOne) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          this.$store.state.loading = true

          await Promise.all([
            this.fetchEmployees({
              company_uuid,
              params: {
                dpc: 'role-to-list-employee',
                is_active: true,
                sort: 'employee_code:asc',
                preset: 'selector',
              },
            }),
            this.fetchHardwares({
              params: {
                dpc: 'role-to-list-hardware',
                sort: 'hardware_code:asc',
                company_uuid,
              },
            }),
            this.fetchOrganizations({
              company_uuid,
              params: {
                dpc: 'role-to-list-organization',
                sort: 'organization_code:asc',
                field: 'organization_uuid,organization_code,title_th',
              },
            }),
            this.fetchPositions({
              company_uuid,
              params: { dpc: 'role-to-list-position' },
            }),
          ])

          if (conditions.MustHaveAll) {
            const mustHaveAllData = Object.keys(conditions.MustHaveAll).map(
              (key) => {
                return {
                  id: uuidv4(),
                  resource: key.split(':').pop(),
                  comparison: !_.isEmpty(conditions.MustHaveAll[key].StringIn)
                    ? 'in'
                    : key.split(':').pop() === 'employee_uuid'
                    ? 'employee'
                    : key.split(':').pop() === 'organization_uuid' &&
                      !_.isEmpty(conditions.MustHaveAll[key].ValidationFunc) &&
                      !_.isEmpty(
                        conditions.MustHaveAll[key].ValidationFunc.UserArg
                      )
                    ? 'organization_under'
                    : key.split(':').pop() === 'organization_uuid' &&
                      !_.isEmpty(conditions.MustHaveAll[key].ValidationFunc) &&
                      !_.isEmpty(
                        conditions.MustHaveAll[key].ValidationFunc.StringArg
                      )
                    ? 'organization_select_under'
                    : 'organization',
                  dataIn:
                    key.split(':').pop() === 'organization_uuid' &&
                    !_.isEmpty(conditions.MustHaveAll[key].ValidationFunc) &&
                    !_.isEmpty(
                      conditions.MustHaveAll[key].ValidationFunc.StringArg
                    )
                      ? this.$store.state.organization.organizations.filter(
                          (h) =>
                            h.organization_uuid ===
                            conditions.MustHaveAll[key].ValidationFunc.StringArg
                        )
                      : _.isEmpty(conditions.MustHaveAll[key].StringIn)
                      ? ''
                      : key.split(':').pop() === 'hardware_uuid'
                      ? this.$store.state.hardware.hardwares.filter((h) => {
                          return conditions.MustHaveAll[key].StringIn.some(
                            (e) => e === h.hardware_uuid
                          )
                        })
                      : key.split(':').pop() === 'organization_uuid'
                      ? this.$store.state.organization.organizations.filter(
                          (h) => {
                            return conditions.MustHaveAll[key].StringIn.some(
                              (e) => e === h.organization_uuid
                            )
                          }
                        )
                      : key.split(':').pop() === 'position_uuid'
                      ? this.$store.state.position.positions.filter((h) => {
                          return conditions.MustHaveAll[key].StringIn.some(
                            (e) => e === h.position_uuid
                          )
                        })
                      : this.$store.state.employee.employees.filter((h) => {
                          return conditions.MustHaveAll[key].StringIn.some(
                            (e) => e === h.employee_uuid
                          )
                        }),
                }
              }
            )
            this.setConditionMustHaveAllList = [...mustHaveAllData]
            this.setConditionMustHaveAllListInit = [...mustHaveAllData]
          }

          if (conditions.AtLeastOne) {
            const atLeastOneData = Object.keys(conditions.AtLeastOne).map(
              (key) => {
                return {
                  id: uuidv4(),
                  resource: key.split(':').pop(),
                  comparison: !_.isEmpty(conditions.AtLeastOne[key].StringIn)
                    ? 'in'
                    : key.split(':').pop() === 'employee_uuid'
                    ? 'employee'
                    : key.split(':').pop() === 'organization_uuid' &&
                      !_.isEmpty(conditions.AtLeastOne[key].ValidationFunc) &&
                      !_.isEmpty(
                        conditions.AtLeastOne[key].ValidationFunc.UserArg
                      )
                    ? 'organization_under'
                    : key.split(':').pop() === 'organization_uuid' &&
                      !_.isEmpty(conditions.AtLeastOne[key].ValidationFunc) &&
                      !_.isEmpty(
                        conditions.AtLeastOne[key].ValidationFunc.StringArg
                      )
                    ? 'organization_select_under'
                    : 'organization',
                  dataIn:
                    key.split(':').pop() === 'organization_uuid' &&
                    !_.isEmpty(conditions.AtLeastOne[key].ValidationFunc) &&
                    !_.isEmpty(
                      conditions.AtLeastOne[key].ValidationFunc.StringArg
                    )
                      ? this.$store.state.organization.organizations.filter(
                          (h) =>
                            h.organization_uuid ===
                            conditions.AtLeastOne[key].ValidationFunc.StringArg
                        )
                      : _.isEmpty(conditions.AtLeastOne[key].StringIn)
                      ? ''
                      : key.split(':').pop() === 'hardware_uuid'
                      ? this.$store.state.hardware.hardwares.filter((h) => {
                          return conditions.AtLeastOne[key].StringIn.some(
                            (e) => e === h.hardware_uuid
                          )
                        })
                      : key.split(':').pop() === 'organization_uuid'
                      ? this.$store.state.organization.organizations.filter(
                          (h) => {
                            return conditions.AtLeastOne[key].StringIn.some(
                              (e) => e === h.organization_uuid
                            )
                          }
                        )
                      : key.split(':').pop() === 'position_uuid'
                      ? this.$store.state.position.positions.filter((h) => {
                          return conditions.AtLeastOne[key].StringIn.some(
                            (e) => e === h.position_uuid
                          )
                        })
                      : this.$store.state.employee.employees.filter((h) => {
                          return conditions.AtLeastOne[key].StringIn.some(
                            (e) => e === h.employee_uuid
                          )
                        }),
                }
              }
            )
            this.setConditionAtLeastOneList = [...atLeastOneData]
            this.setConditionAtLeastOneListInit = [...atLeastOneData]
          }

          this.dialogSetConditions = true
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      } else {
        this.dialogSetConditions = true
      }
    },
    handleCancelDialogPersonalRole() {
      this.dialogPersonalRole = false
      this.employeePersonalPolicy = JSON.parse(
        JSON.stringify(this.employeePersonalPolicyInit)
      )
    },
    handleChooseRole(statementId) {
      this.dialogAddUserRole = true
      this.statementId = statementId
    },
    handleSelectedRole(resource) {
      this.employeePersonalPolicy.personal_policy.Statements =
        this.employeePersonalPolicy.personal_policy.Statements.map(
          (statement) => {
            if (statement.id === this.statementId) {
              return {
                ...statement,
                Resource: resource,
                TitleTH: this.policySpecification.PolicySpecs[resource].TitleTH,
                Actions: this.policySpecification.PolicySpecs[
                  resource
                ].ActionPropertiesRequired.map((action) => {
                  return {
                    ...action,
                    hasProperties: !_.isEmpty(action.Properties),
                    Actions: action.Actions.map((action) => {
                      return {
                        ...action,
                        checked: true,
                      }
                    }),
                  }
                }),
              }
            }

            return statement
          }
        )
      this.dialogAddUserRole = false
    },
    async handleUpdatePersonalRole() {
      try {
        this.$store.state.loading = true

        await Promise.all([
          this.fetchEmployeePersonalPolicy({
            company_uuid: this.$store.state.authentication.company.company_uuid,
            employee_uuid: this.employeePolicy.employee_uuid,
          }),
          this.fetchPolicySpecification(),
        ])

        if (
          this.$store.state.employeePolicy.employeePersonalPolicy
            .personal_policy
        ) {
          this.employeePersonalPolicyFormatData()
        }

        this.dialogPersonalRole = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },

    employeePersonalPolicyFormatData() {
      const employeePersonalPolicy = {
        ...this.$store.state.employeePolicy.employeePersonalPolicy,
        personal_policy: {
          Version:
            this.$store.state.employeePolicy.employeePersonalPolicy
              .personal_policy.Version,
          PolicyID:
            this.$store.state.employeePolicy.employeePersonalPolicy
              .personal_policy.PolicyID,
          Statements: _.uniqBy(
            this.$store.state.employeePolicy.employeePersonalPolicy
              .personal_policy.Statements,
            'Resource'
          ).map((statement) => {
            return {
              ...statement,
              id: uuidv4(),
              TitleTH:
                this.$store.state.userRole.policySpecification.PolicySpecs[
                  statement.Resource
                ].TitleTH,
              Actions:
                this.$store.state.userRole.policySpecification.PolicySpecs[
                  statement.Resource
                ].ActionPropertiesRequired.map((action) => {
                  return {
                    ...action,
                    id: uuidv4(),
                    hasProperties: !_.isEmpty(action.Properties),
                    Conditions:
                      this.$store.state.employeePolicy.employeePersonalPolicy.personal_policy.Statements.find(
                        (item) =>
                          item.Actions.some((item) =>
                            action.Actions.some((s) => s.Action === item)
                          )
                      )?.Conditions || {},
                    Actions: action.Actions.map((action) => {
                      return {
                        ...action,
                        checked:
                          this.$store.state.employeePolicy.employeePersonalPolicy.personal_policy.Statements.map(
                            (item) => item.Actions
                          )
                            .reduce((acc, curr) => acc.concat(curr), [])
                            .includes(action.Action),
                      }
                    }),
                  }
                }),
            }
          }),
        },
      }

      this.employeePersonalPolicy = JSON.parse(
        JSON.stringify(employeePersonalPolicy)
      )
      this.employeePersonalPolicyInit = JSON.parse(
        JSON.stringify(employeePersonalPolicy)
      )
    },

    async handleDeleteCondition(title, id) {
      this.confirmDialogDeleteCondition = true
      this.confirmDialogDeleteConditionData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบเงื่อนไข',
        value: title,
        item: id,
      }
    },
    cancelConfirmDialogDeleteCondition() {
      this.confirmDialogDeleteCondition = false
    },
    async submitConfirmDialogDeleteCondition(id) {
      try {
        this.confirmDialogDeleteConditionLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const Statements = []
        this.employeePersonalPolicy.personal_policy.Statements.forEach(
          (statement) => {
            statement.Actions.forEach((action) => {
              Statements.push({
                Effect: 'Allow',
                Resource: statement.Resource,
                Actions: action.Actions.filter((action) => action.checked).map(
                  (action) => action.Action
                ),
                Conditions: action.id === id ? {} : action.Conditions,
              })
            })
          }
        )

        const employeePersonalPolicy = {
          personal_policy: {
            Version: this.employeePersonalPolicy.personal_policy.Version || 1,
            Statements,
          },
        }

        const payload = {
          company_uuid,
          employee_uuid: this.employeePolicy.employee_uuid,
          data: employeePersonalPolicy,
        }

        await this.updateEmployeePersonalPolicy(payload)

        await this.fetchEmployeePersonalPolicy({
          company_uuid,
          employee_uuid: this.employeePolicy.employee_uuid,
        })
        this.employeePersonalPolicyFormatData()

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeleteConditionLoading = false
        this.confirmDialogDeleteCondition = false
      }
    },

    handleDeleteEmployeePolicyRoles(item) {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: `คุณต้องการลบบทบาท`,
        value: item.title,
        item,
      }
    },

    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },

    async submitConfirmDialogDelete(item) {
      try {
        this.confirmDialogDeleteLoading = true

        const payload = {
          company_uuid: this.$store.state.authentication.company.company_uuid,
          employee_uuid: this.employeePolicy.employee_uuid,
          data: {
            roles: this.employeePolicy.roles
              .filter((role) => role.role_uuid !== item.role_uuid)
              .map((role) => role.role_uuid),
          },
        }

        const response = await this.updateEmployeePolicyRoles(payload)
        this.$emit('updateEmployeePolicyRoles', response)

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบบทบาทสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false
      }
    },

    handleDeleteEmployeePersonalRole(item) {
      this.confirmDialogDeletePersonalRole = true
      this.confirmDialogDeletePersonalRoleData = {
        title: 'ยืนยันการลบ',
        text: `คุณต้องการลบสิทธิ์ส่วนตัว`,
        value: `${item.firstname_th} ${item.lastname_th}`,
        item,
      }
    },

    cancelConfirmDialogDeletePersonalRole() {
      this.confirmDialogDeletePersonalRole = false
    },

    async submitConfirmDialogDeletePersonalRole(item) {
      try {
        this.confirmDialogDeletePersonalRoleLoading = true

        const payload = {
          company_uuid: this.$store.state.authentication.company.company_uuid,
          employee_uuid: item.employee_uuid,
        }

        await this.deleteEmployeePersonalPolicy(payload)
        const response = await this.fetchEmployeePolicy(payload)
        this.$emit('updateEmployeePolicyRoles', response)

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบบทบาทสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogDeletePersonalRoleLoading = false
        this.confirmDialogDeletePersonalRole = false
      }
    },
    async handleOnSaveDialogRoles() {
      try {
        const roles = _.uniqBy(
          [...this.employeePolicy.roles, ...this.selectedRoles],
          'role_uuid'
        ).map((item) => item.role_uuid)

        this.dialogRoles = false

        this.$store.state.loading = true

        const payload = {
          company_uuid: this.$store.state.authentication.company.company_uuid,
          employee_uuid: this.employeePolicy.employee_uuid,
          data: {
            roles,
          },
        }

        const response = await this.updateEmployeePolicyRoles(payload)
        this.$emit('updateEmployeePolicyRoles', response)

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'เพิ่มบทบาทสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    handleOnCloseDialogRoles() {
      this.dialogRoles = false
      this.selectedRole = []
    },
    handleOnCancelDialogRoles() {
      this.dialogRoles = false
      this.selectedRole = []
    },
    async handleAddEmployeePolicyRole() {
      try {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        await this.fetchUserRoles(company_uuid)

        this.dialogRoles = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    handleAddRole() {
      this.employeePersonalPolicy.personal_policy.Statements.push({
        id: uuidv4(),
      })
    },
    handleDeleteRole(statementId) {
      this.employeePersonalPolicy.personal_policy.Statements =
        this.employeePersonalPolicy.personal_policy.Statements.filter(
          (statement) => statement.id !== statementId
        )
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const updateEmployeePersonalPolicy = {
            personal_policy: {
              Version:
                this.employeePersonalPolicy.personal_policy?.Version || 1,
              Statements:
                this.employeePersonalPolicy.personal_policy.Statements.map(
                  (statement) => {
                    return {
                      Effect: statement?.Effect || 'Allow',
                      Resource: statement.Resource,
                      Actions: this.getActions(statement.Actions),
                      Conditions: {
                        AtLeastOne: {},
                        MustHaveAll: {},
                      },
                    }
                  }
                ),
            },
          }

          const payload = {
            company_uuid,
            employee_uuid: this.employeePolicy.employee_uuid,
            data: updateEmployeePersonalPolicy,
          }

          await this.updateEmployeePersonalPolicy(payload)
          const response = await this.fetchEmployeePolicy(payload)
          this.$emit('updateEmployeePolicyRoles', response)

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          // this.employeePersonalPolicy = {
          //   personal_policy: {
          //     Statements: []
          //   }
          // }
          // this.employeePersonalPolicyInit = {
          //   personal_policy: {
          //     Statements: []
          //   }
          // }
        } catch (error) {
          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
          this.dialogPersonalRole = false

          this.employeePersonalPolicy = {
            personal_policy: {
              Statements: [],
            },
          }
          this.employeePersonalPolicyInit = {
            personal_policy: {
              Statements: [],
            },
          }
        }
      }
    },
    getActions(items) {
      const actions = []
      items.forEach((action) => {
        action.Actions.forEach((action) => {
          if (action.checked) {
            actions.push(action.Action)
          }
        })
      })
      return actions
    },
    onClose() {
      if (this.isEmployeePersonalPolicyDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.dialogPersonalRole = false
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.dialogPersonalRole = false
      this.employeePersonalPolicy = JSON.parse(
        JSON.stringify(this.employeePersonalPolicyInit)
      )
    },
  },
}
</script>
